<template>
  <Layout>
    <template v-slot:default>
      <q-page
        class="q-pa-xl centered-container-small row fit"
        style="max-width: 820px !important"
      >
        <div class="col-12">
          <span class="text-h4">{{ i18n.page_title }}</span>
        </div>

        <div
          v-if="!invitation"
          class="full-width items-strech row wrap fit fill-height justify-center items-center content-center q-mb-xl"
          style="margin-bottom: 160px"
        >
          <div class="col-12 text-center">
            <!-- Invitaiton Not Found Illustration -->
            <img
              :src="$q.dark.isActive ? '/illustrations/no_content_dark.svg' : '/illustrations/no_content.svg'"
              alt="Aucune invitation"
              class="q-img-responsive inline-block"
              width="450"
            >
          </div>
          <div class="row full-width no-wrap justify-center text-center">
            <h5 class="text-bold">
              {{ i18n.invitation_not_found }}
            </h5>
          </div>

          <div class="row full-width no-wrap justify-center q-mt-md">
            <Link :href="leave_action.link">
              <q-btn
                unelevated=""
                icon="las la-home"
                color="primary"
                :label="leave_action.label"
              />
            </Link>
          </div>
        </div>

        <div
          v-else
          class="full-width items-strech row wrap fit fill-height justify-center items-center content-center"
        >
          <q-card class="q-ma-xl invitation-card-shadow full-width">
            <q-avatar
              size="128px"
              class="q-card-bordered card-background"
              flat
              style="border-radius: 50%; position: absolute; left: calc(50% - 64px); top: -64px"
            >
              <Jdenticon
                :text="invitation.workspace_id"
                class=""
                :size="86"
              />
            </q-avatar>

            <q-card-section class="text-center q-ma-lg q-mt-xl">
              <div class="text-h6 text-bold">
                {{ invitation.workspace_name }}
              </div>
              <div
                v-if="invitation.workspace_siren"
                class="text-caption text-grey-6"
              >
                SIREN: {{ invitation.workspace_siren }}
              </div>
            </q-card-section>
            <q-separator
              inset
              class="q-mx-xl"
            />
            <q-card-section class="text-center q-my-lg q-mx-lg">
              <div class="text-body2">
                <q-avatar
                  size="xs"
                  style="margin-bottom: 2px"
                  class="q-mr-sm"
                >
                  <img
                    :src="invitation.user_avatar_url"
                    referrerpolicy="no-referrer"
                  >
                </q-avatar>
                <b>{{ invitation.user_name }}</b>
                {{ i18n.user_invite_you }}
              </div>
            </q-card-section>
            <q-card-section class="text-center q-my-lg q-mx-xl">
              <!-- Accept / Decline -->
              <div class="row no-wrap justify-around">
                <q-btn
                  unelevated
                  rounded
                  color="negative"
                  class="text-white q-px-lg"
                  :label="i18n.action_decline"
                  :disable="invitation.wrong_user"
                  no-caps
                  @click="invitations_respond(invitation.action_reject_link)"
                />

                <q-btn
                  color="positive"
                  class="q-px-lg"
                  unelevated
                  rounded
                  no-caps
                  :label="i18n.action_accept"
                  :disable="invitation.wrong_user"
                  @click="invitations_respond(invitation.action_accept_link)"
                />
              </div>
            </q-card-section>

            <q-inner-loading :showing="invitation_loading">
              <q-spinner-tail
                size="50px"
                color="primary"
              />
            </q-inner-loading>
          </q-card>

          <!-- Wrong User Banner -->
          <div
            v-if="invitation.wrong_user"
            class="col-12 q-px-xl"
          >
            <q-banner
              class="bg-pastel-orange q-pa-md"
              dense
            >
              <template v-slot:avatar>
                <q-icon
                  name="las la-exclamation-triangle"
                  size="lg"
                />
              </template>
              <div class="text-caption text-dark">
                <span v-html="invitation.wrong_user_message" />
              </div>
            </q-banner>
          </div>
        </div>
      </q-page>
    </template>
  </Layout>
</template>
<script>
import Layout from '@/layouts/wide.vue';
import Jdenticon from '@/shared/jdenticon.vue';
import { Link } from '@inertiajs/vue3';

export default {
  components: {
    Jdenticon,
    Layout,
    Link,
  },
  props: {
    i18n: {
      type: Object,
      required: true,
    },
    leave_action: {
      type: Object,
      required: true,
    },
    invitation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      invitation_loading: false,
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    $t: function(str, o) {
      console.log(str, o);
      return `missing: ${str}`;
    },
    invitations_respond: function (link) {
      this.$inertia.put(
        link,
        {},
        {
          preserveState: true,
          preserveScroll: true,
          onStart: () => {
            this.invitation_loading = true;
          },
          onSuccess: () => {
            this.$q.notify({
              message: this.$page.props.flash.success,
              type: "positive",
            });
          },
          onError: (errors) => {
            console.log(errors);
            this.$q.notify({
              message: this.$page.props.flash.alert,
              type: "negative",
            });
          },
          onFinish: () => {
            this.invitation_loading = false;
          },
        }
      );
    },
  },
};
</script>
